import React from 'react'

const StructuredData = () => {
  // Ana Organization Schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Flekspro",
    "alternateName": "Flekspro A.Ş.",
    "description": "Antalya'da profesyonel personel çözümleri. Restoran, otel, market, ofis ve daha fazlası için kaliteli personel hizmeti. 24 saat içinde yanıt garantisi.",
    "url": "https://flekspro.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://flekspro.com/logo.png",
      "width": 512,
      "height": 512
    },
    "image": "https://flekspro.com/logo.png",
    "sameAs": [
      "https://www.facebook.com/Flekspro/",
      "https://www.instagram.com/flekspro/",
      "https://www.linkedin.com/company/flekspro",
      "https://x.com/flekspro"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+908505325989",
      "contactType": "customer service",
      "areaServed": "TR",
      "availableLanguage": ["Turkish", "English"]
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Şirinyalı mah. 1513 sk. No: 9/2",
      "addressLocality": "Muratpaşa",
      "addressRegion": "Antalya",
      "postalCode": "07000",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 36.8969,
      "longitude": 30.7133
    },
    "foundingDate": "2020",
    "numberOfEmployees": "50-100",
    "knowsAbout": [
      "Personel Çözümleri",
      "İnsan Kaynakları",
      "Geçici Personel",
      "Kalıcı Personel",
      "Restoran Personeli",
      "Otel Personeli",
      "Market Personeli",
      "Ofis Personeli"
    ]
  }

  // LocalBusiness Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Flekspro",
    "image": "https://flekspro.com/logo.png",
    "description": "Antalya'da profesyonel personel çözümleri sunan yerel işletme",
    "url": "https://flekspro.com",
    "telephone": "+908505325989",
    "email": "info@flekspro.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Şirinyalı mah. 1513 sk. No: 9/2",
      "addressLocality": "Muratpaşa",
      "addressRegion": "Antalya",
      "postalCode": "07000",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 36.8969,
      "longitude": 30.7133
    },
    "openingHours": "Mo-Su 08:00-18:00",
    "priceRange": "$$",
    "paymentAccepted": ["Cash", "Credit Card", "Bank Transfer"],
    "currenciesAccepted": "TRY",
    "areaServed": {
      "@type": "City",
      "name": "Antalya"
    }
  }

  // Service Schema
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Profesyonel Personel Çözümleri",
    "description": "Restoran, otel, market, ofis ve daha fazlası için kaliteli personel hizmeti. 24 saat içinde yanıt garantisi.",
    "provider": {
      "@type": "Organization",
      "name": "Flekspro"
    },
    "areaServed": {
      "@type": "City",
      "name": "Antalya"
    },
    "serviceType": "Personel Hizmetleri",
    "category": "İnsan Kaynakları",
    "offers": {
      "@type": "Offer",
      "description": "Kaliteli personel çözümleri",
      "availability": "https://schema.org/InStock"
    }
  }

  // WebSite Schema
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Flekspro",
    "url": "https://flekspro.com",
    "description": "Flekspro resmi web sitesi - Profesyonel personel çözümleri",
    "publisher": {
      "@type": "Organization",
      "name": "Flekspro"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://flekspro.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }

  // BreadcrumbList Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Ana Sayfa",
        "item": "https://flekspro.com"
      }
    ]
  }

  return (
    <>
      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      
      {/* LocalBusiness Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      
      {/* Service Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
      
      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      
      {/* BreadcrumbList Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  )
}

export default StructuredData
